import type { MachineContext } from '../Diagnosis.machine.types'

export const getCurrentPageData = (pageData: MachineContext['pageData']) => {
  return pageData[pageData.length - 1]
}
